<template>
  <div class="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
    <div class="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-2xl flex flex-col items-center space-y-4 max-w-sm mx-4">
      <!-- Spinner -->
      <div class="relative">
        <div class="w-12 h-12 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
        <div class="absolute top-0 left-0 w-12 h-12 border-4 border-primary-600 rounded-full animate-spin border-t-transparent"></div>
      </div>
      
      <!-- Loading text -->
      <div class="text-center">
        <h3 class="text-lg font-medium text-gray-900 dark:text-white">{{ title }}</h3>
        <p v-if="message" class="text-sm text-gray-500 dark:text-gray-400 mt-1">{{ message }}</p>
      </div>
      
      <!-- Progress bar (optional) -->
      <div v-if="showProgress" class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
        <div 
          class="bg-primary-600 h-2 rounded-full transition-all duration-300 ease-out"
          :style="{ width: `${progress}%` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
withDefaults(defineProps(), {
  title: 'Loading...',
  message: '',
  showProgress: false,
  progress: 0
})
</script>